import * as Constants from '../../constants.js';

import { useEffect, useState } from 'react';

import { faCertificate, faMobile, faPlug, faTools, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from '../../components/widget/Card';
import classes from './Admin.module.css';
import Dashboard from '../../components/widget/Dashboard';

function AdminPage(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [commitments, setCommitments] = useState([]);    

    useEffect(() => {

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {

            try {

                setIsLoading(true);

                const token = localStorage.getItem("token");

                const headers = {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'externalsystem/json'
                };

                const [commitmentsRes] = await Promise.all([
                    fetch(Constants.COMMITMENTS_LIST, { method: 'GET', signal, headers })
                ]);

                if (!commitmentsRes.ok) {
                    const err = await commitmentsRes.json();
                    throw err;
                }

                const commitmentsJson = await commitmentsRes.json();

                if (commitmentsJson.status === "success") {
                    setCommitments(commitmentsJson.data);
                }
            } catch (error) {

                if (error.name !== 'AbortError') {
                    console.error(error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    return <>
        <div className="container mt-4 pb-5">
            <Dashboard commitments={commitments} />
        </div>
    </>
}

export default AdminPage;